import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { KnowYourCustomerResults } from '../../interfaces/know-your-customer-results/know-your-customer-results';
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';

@Injectable({
    providedIn: 'root'
})
export class KnowYourCustomerResultsRepositoryService {
    protected _baseLink: string;

    constructor(
        private http: HttpClient,
        @Inject(REG_HUB_COMMON_CONFIG) config: RegHubCommonConfig) {
        this._baseLink = `${config.rootUrl}`;
    }

    public getKnowYourCustomerResults(orderID: string): Observable<KnowYourCustomerResults> {
        return this.http.get<KnowYourCustomerResults>(`${this._baseLink}/Orders/${orderID}/KnowYourCustomerResults`);
    }
}